module.exports = __webpack_public_path__ + "static/media/ic-members.51644de3.svg";